module.exports = __webpack_public_path__ + "first-20_raised_print.jpg?ac2d095c6c16eed1953ec728d4ec31e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_raised_print.jpg
// module id = 503
// module chunks = 0